/**
 * Created by Vladislav on 07.03.2025.
 */

cleverapps.InitByFeature["daily_cup"] = function () {
    cleverapps.dailyCup = new Cup(CupsConfig.TYPE_DAILY);
};